define('ScrollBarWidth',['jquery'], function ($) {
  var scrollBarWidth = {
    detectIE: function () {
      var ua = window.navigator.userAgent;
      var msie = ua.indexOf('MSIE ');
      if (msie > 0) {
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
      }
      var trident = ua.indexOf('Trident/');
      if (trident > 0) {
        var rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
      }
      var edge = ua.indexOf('Edge/');
      if (edge > 0) {
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
      }
      return false;
    },
    getwidth: function () {
      if (scrollBarWidth.detectIE()) {
        return 0;
      }
      var inner = document.createElement('p');
      inner.style.width = '100%';
      inner.style.height = '200px';
      var outer = document.createElement('div');
      outer.style.position = 'absolute';
      outer.style.top = '0px';
      outer.style.left = '0px';
      outer.style.visibility = 'hidden';
      outer.style.width = '200px';
      outer.style.height = '150px';
      outer.style.overflow = 'hidden';
      outer.appendChild(inner);
      document.body.appendChild(outer);
      var w1 = inner.offsetWidth;
      outer.style.overflow = 'scroll';
      var w2 = inner.offsetWidth;
      if (w1 === w2) w2 = outer.clientWidth;
      document.body.removeChild(outer);
      return w1 - w2;
    },
    scrollWidth: function () {
      if (!sessionStorage.getItem('browserScrollWidth')) {
        sessionStorage.setItem('browserScrollWidth', scrollBarWidth.getwidth());
      }
    }
  };

  if (typeof Sitecore != typeof void 0 && typeof Sitecore.PageModes != typeof void 0 && Sitecore.PageModes != null && Sitecore.PageModes.PageEditor != null) return;
  setTimeout(scrollBarWidth.scrollWidth, 0);
});

